var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconQueue = function SvgIconQueue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.543 10.32a4.16 4.16 0 1 0 0-8.32 4.16 4.16 0 0 0 0 8.32Zm10.808 0a3.39 3.39 0 1 0 0-6.78 3.39 3.39 0 0 0 0 6.78ZM4.16 13.25h15.68c2.29 0 4.16 1.77 4.16 3.96s-1.87 3.96-4.16 3.96H4.16C1.87 21.17 0 19.4 0 17.21s1.87-3.96 4.16-3.96Zm10.7 6.74h4.98c1.64 0 2.97-1.25 2.97-2.77s-1.33-2.77-2.97-2.77h-4.98c-1.64 0-2.97 1.25-2.97 2.77s1.33 2.77 2.97 2.77Z"
  })));
};
export default SvgIconQueue;